import { useQuery } from "@tanstack/react-query";

import { useAuth } from "contexts/AuthContext";
import { Floor } from "utils/floor";

type GetFloorResponseData = {
  data: Floor[];
  errors: any[];
}

export const useGetProjectFloorsQuery = (
  projectId: string,
  workspace?: string
) => {
  const { authApi } = useAuth();

  const result = useQuery({
    queryKey: workspace
      ? ["floors", projectId, workspace]
      : ["floors", projectId],
    queryFn: async () => {
      if (projectId === "") return [];
      const path = workspace
        ? `/project/${projectId}/floors/?workspace=${workspace}`
        : `/project/${projectId}/floors`;

      const { data: responseBody } = await authApi.get<GetFloorResponseData>(path);
      return responseBody.data;
    },
  });

  return result;
};
